<template>
    <b-card
        class="agent-contact-info-card"
        body-class="text-center"
    >
        <home-company-logo
            v-if="logo"
            :logo-src="logo"
        />

        <agent-contact-info :landing-page="landingPage" />
    </b-card>
</template>

<script>
    import './AgentContactInfoCard.scss';
    import HomeCompanyLogo from "../HomeCompanyLogo/HomeCompanyLogo";
    import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";
    import AgentContactInfo from "../AgentContactInfo/AgentContactInfo";

    export default {
        name: "AgentContactInfoCard",
        components: {AgentContactInfo, HomeCompanyLogo},

        props: {
            landingPage: {
                type: LandingPageAppResource,
                required: true,
            }
        },

        computed: {
            logo() {
                return (this.landingPage.organizationLogo || {}).publicStorageUrl || null;
            },
        },
    };
</script>
